var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"colophon"}},[_c('ul',{attrs:{"id":"linklist"}},[_c('li',[_c('a',{staticClass:"button",attrs:{"href":_vm.uitlegURL,"target":"_blank"}},[_c('span',[_vm._v("Uitleg")])])]),_c('li',[_c('a',{staticClass:"button",attrs:{"href":_vm.moreURL,"target":"_blank"}},[_c('span',[_vm._v("Meer")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }